import { css } from 'lit';

export default css`
  :host {
    flex-direction: column;
  }

  :host([has-groups]) {
    border-block-end: var(--sl-color-elevation-border-raised) solid var(--sl-size-borderWidth-default);
    margin-block-end: var(--sl-size-075);
    padding-block-end: var(--sl-size-100);
  }

  :host([has-groups]) .other {
    display: none;
  }

  :host([has-groups]) sl-option::part(wrapper) {
    display: flex;
    flex: 1;
    justify-content: space-between;
  }

  .group {
    color: var(--sl-color-foreground-plain);
  }

  .other {
    border-block-start: var(--sl-color-elevation-border-raised) solid var(--sl-size-borderWidth-default);
    margin-block: var(--sl-size-075) var(--sl-size-025);
    padding-block-start: var(--sl-size-175);
    padding-inline-start: var(--sl-size-300);
  }

  sl-option:first-of-type {
    margin-block-start: var(--sl-size-025);
  }
`;
